import script from "./OrderCrossConnect.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderCrossConnect.vue?vue&type=script&setup=true&lang=js"

import "./OrderCrossConnect.vue?vue&type=style&index=0&id=3aa75379&lang=scss"

const __exports__ = script;

export default __exports__